import * as React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

// Selectors
import { selectPieceRateEntryExists } from 'services/timesheetTimesheetEntriesForm/selectors';

interface Props {
    pieceRateEntryExists?: ?boolean;
    children: React.Node;
}

export class PieceRateEntryExistsGate extends React.PureComponent<Props> {
    render() {
        const { pieceRateEntryExists, children } = this.props;
        if (!pieceRateEntryExists) return null;
        return children;
    }
}

const mapStateToProps = createStructuredSelector({
    pieceRateEntryExists: selectPieceRateEntryExists
});

export default connect(mapStateToProps)(PieceRateEntryExistsGate);
